import React, { useState } from "react";
import appSettings from "../settings/appSettings";
import { replacePronouns } from "../helpers/helpers";
import { Modal } from "slide-ui";
import PrivacyStatement from "./PrivacyStatement";

export default function ChildProfileHeader({
  childData,
  rflGroup,
  emailallowed,
}) {
  const { countryImage, childPrivacyUrl, emailMyChildUrl, replaceTokens } =
    appSettings;
  const {
    guid,
    identifier,
    supportOfficeChildId,
    isWebpublishable,
    givenName,
    cgpWebUrl,
    projectIdentifier,
    projectName,
    countryName,
    countryCode,
    age,
    childGender,
    gender,
    birthdate,
    birthYear,
    birthMonth,
    birthMonthName,
    birthDay,
  } = childData;

  const [showModal, setShowModal] = useState(false);
  const handleModal = (e) => {
    setShowModal(!showModal);
    //prevent the "#" from showing up in the url.
    e.preventDefault();
  };

  const getCountryImageUrl = () => {
    try {
      const imageUrl = `${countryImage.path}/${countryCode.toUpperCase()}.jpg`;
      return imageUrl;
    } catch (err) {
      return `${countryImage.path}/${countryImage.fallback}.jpg`;
    }
  };

  const countryImageUrl = getCountryImageUrl();
  const WebpubishablePrivacy = () => {
    if (isWebpublishable) {
      return null;
    }

    return (
      <>
        <div className="child-privacy msc-profile-pic-inner">
          Your child lives in an area where online photos and videos of children
          are restricted.
          <br />
          <a
            href="#"
            onClick={(e) => handleModal(e)}
            data-wv-target="#childPrivacyModal"
            data-wv-modal="true"
          >
            Learn More
          </a>
        </div>
        <Modal
          toggle={() => setShowModal(false)}
          isOpen={showModal}
          hasTitle={false}
          hasFooter={false}
        >
          <PrivacyStatement />
        </Modal>
      </>
    );
  };

  const EmailChildAlert = () => {
    if (emailallowed != "true") {
      return null;
    }

    let emcText =
      "Send " +
      givenName +
      " a final word of encouragement and let {him_her} know the impact {he_she}'s had on your life.";
    emcText = replacePronouns(emcText, gender, replaceTokens);

    return (
      <div className="emc-alert-wrapper row">
        <div className="col-md-10 col-sm-10 col-sm-offset-1 col-md-offset-1">
          <p>
            {emcText}{" "}
            <a
              href={emailMyChildUrl + "?childid=" + identifier}
              className="btn btn-ghost-white"
            >
              Email now
            </a>
          </p>
        </div>
      </div>
    );
  };

  const styleChildCountryBackground = {
    backgroundImage: `url('${countryImageUrl}')`,
    backgroundPositionX: "center",
    backgroundPositionY: "center",
  };

  const childPhotoStyle = {
    backgroundImage: `url('${cgpWebUrl}')`,
    backgroundColor: "#ffffff",
  };

  return (
    <div id="msc-header" className="ChildProfileHeader">
      <section
        className="child-intro container-fluid"
        style={styleChildCountryBackground}
      >
        <EmailChildAlert />
        <div className="row">
          <div className="col-xs-12 child-image-frame">
            <div className="img-circle msc-profile-pic">
              <div
                className="msc-profile-pic-inner"
                style={childPhotoStyle}
              ></div>
              <WebpubishablePrivacy />
            </div>
          </div>
          <div className="col-xs-12 child-more-info">
            <div className="child-name msc-name">{givenName}</div>
            <div className="msc-specs">
              <span className="msc-details child-gender">
                <span className="child-more-info-item">{childGender}</span>
              </span>
              {rflGroup != "memorial" ? (
                <span className="msc-details child-age">
                  <i className="fa fa-circle fa-1"></i>
                  <span className="child-more-info-item">Age {age}</span>
                </span>
              ) : (
                ""
              )}
              <span className="msc-details child-country">
                <i className="fa fa-circle fa-1"></i>
                <span className="child-more-info-item">{countryName}</span>
              </span>
              <span className="msc-details child-birthday-data">
                <i className="fa fa-circle fa-1"></i>
                <span className="child-more-info-item">
                  <i className="fa fa-birthday-cupcake"></i> {birthMonthName}{" "}
                  {birthDay}
                </span>
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

/*



*/
